import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#32b9e3',
      light: '#5ca1cf',
      dark: '#1a8d99',
    },
    secondary: {
      main: '#1a8d99',
      light: '#1a8d99',
    },
    background: {
      // O `CssBaseline` escreve `body { background-color }` via Emotion e ganha do
      // `index.scss` por ordem de inserção — para o tema NEBI valer no body, o token
      // tem que entrar aqui, na origem. O resto da paleta MUI segue como estava
      // (ainda serve as telas não migradas).
      default: 'var(--nebi-paper)',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: 'Inter, Montserrat, Roboto, sans-serif',
    h1: {
      fontFamily: 'Montserrat, sans-serif',
      fontWeight: 700,
    },
    h2: {
      fontFamily: 'Montserrat, sans-serif',
      fontWeight: 600,
    },
    h3: {
      fontFamily: 'Montserrat, sans-serif',
      fontWeight: 600,
    },
    button: {
      textTransform: 'none',
      fontWeight: 500,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '10px 24px',
        },
        contained: {
          background: 'linear-gradient(to right, #5ca1cf, #32b9e3, #1a8d99, #1a8d99, #1a8d99)',
          color: '#fff',
          '&:hover': {
            background: 'linear-gradient(to right, #4a8fb5, #2aa7c9, #1a8d99, #1a8d99, #1a8d99)',
          },
        },
      },
    },
    MuiSnackbar: {
      styleOverrides: {
        root: {
          marginTop: '100px',
        },
      },
    },
  },
});
